/* eslint-disable no-unused-expressions */
/* eslint-disable dot-notation */
/* eslint-disable camelcase */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
import { format, isValid, add } from 'date-fns';
import {
  forEach, chunk, isEmpty, isArray, find, cloneDeep, omit, remove, includes,
} from 'lodash-es';

import { ETransportValue } from '@/components/filtry/types/ETransportValue';
import { formatDatyBackend, dateDisplayFormat } from '@/terminy.config.js';
import { lowerCaseKeys } from '~/helper-functions/store/lowerCaseKeys';
import { prepareCenaParam, prepareDatyUrodzeniaParam, prepareDlugoscPobytuParam } from '~/helper-functions/url/nuxt3-params';
import ETypyWyjazdu from '~/types/ETypyWyjazdu';

const queryString = require('query-string');

const wybraneSkadPolaczone = {
  bydgoszcz: 'bydgoszcz,BZG',
  gdansk: 'gdansk,GDN',
  katowice: 'katowice,KTW',
  krakow: 'KRK,krakow',
  lublin: 'LUZ,lublin',
  lodz: 'lodz,LCJ',
  poznan: 'poznan,POZ',
  rzeszow: 'rzeszow,RZE',
  szczecin: 'szczecin,SZZ',
  warszawa: 'WAW,WMI,warszawa',
  wroclaw: 'wroclaw,WRO',
};

const setDateParams = (data) => {
  let dataStart;
  let dataKoniec = '';

  if (data?.length >= 1) {
    dataStart = format(data[0], formatDatyBackend);
  }

  if (data?.length >= 2) {
    dataKoniec = format(data[1], formatDatyBackend);
  }

  return { dataStart, dataKoniec };
};

export const parseDatesOfBirth = (dates) => {
  const array = [];

  forEach(dates, (element) => {
    array.push(format(element, formatDatyBackend));
  });
  return array;
};

const setTerminyWyjazdu = (dateStart, dateEnd) => {
  if (!dateStart && !dateEnd) return;

  if (dateStart && !dateEnd) {
    return [dateStart];
  }

  return [dateStart, dateEnd];
};
const setLokalizacje_HoteloProdukt = (wybraneDokad, hoteloProdukt) => {
  const lokaliacje = cloneDeep(wybraneDokad);
  let array = [];

  if (!lokaliacje.length && !hoteloProdukt.length) return;

  if (lokaliacje.length) array = lokaliacje;

  if (!hoteloProdukt.length) return array;

  forEach(hoteloProdukt, (item) => {
    array.push(item.Wartosc);
  });
  return array;
};

const setTypTransportu = (typTransportu) => {
  if (typTransportu === ETransportValue.air) return [typTransportu, ETransportValue.dreamliner];

  return [typTransportu];
};

export const parseWyszukajBody = (rootState) => {
  const datesOfBirth = parseDatesOfBirth(rootState.filtry.datyUrodzenia);
  const { dataStart, dataKoniec } = setDateParams(rootState.filtry.data);

  const body = {
    AtrybutyMulti: {},
    AtrybutySingle: {},
    DatyUrodzenia: datesOfBirth,
    LiczbaPokoi: rootState.filtry.dowolnaLiczbaPokoi && rootState.filtry.disabledPokoje ? null : rootState.filtry.liczbaPokoi,
    Sortowanie: rootState.szukaj.wybrane.sortowanie ? rootState.szukaj.wybrane.sortowanie.Klucz : '',
    CzyWeekendowka: rootState.filtry.defaultSetting.CzyWeekendowa,
  };

  if (rootState.szukaj.routeInfo?.Filtr?.OfertySortowanie) {
    body.OfertySortowanie = cloneDeep(rootState.szukaj.routeInfo.Filtr.OfertySortowanie);
  }

  const wybrane = cloneDeep(rootState.filtryBoczne.wybrane);

  wybrane.Miasta = cloneDeep(rootState.filtry.wybraneSkad);

  for (const key in wybrane) {
    if (isEmpty(wybrane[key])) {
      continue;
    }

    if (isArray(wybrane[key])) body.AtrybutyMulti[key] = wybrane[key];
    else {
      const arr = [];

      if (key === 'Cena') {
        if (wybrane[key].selected) arr.push(wybrane[key].selected);

        if (wybrane[key].value) arr.push(wybrane[key].value);
      } else {
        if (wybrane[key].value) arr.push(wybrane[key].value);

        if (wybrane[key].selected) arr.push(wybrane[key].selected);
      }

      if (!isEmpty(arr)) body.AtrybutySingle[key] = arr;
    }

    // wykluczenie zawierajacych sie filtrow
    if (
      key === ETypyWyjazdu.typWartosc
      && includes(wybrane[key], ETypyWyjazdu.objazd)
      && includes(wybrane[key], ETypyWyjazdu.objazdPotwierdzony)
    ) {
      const typyWyjazdu = wybrane[key];

      typyWyjazdu.forEach((elem, index, arr) => {
        if (elem === ETypyWyjazdu.objazd) {
          arr.splice(index, 1);
        }
      });
    }

    if (
      key === ETypyWyjazdu.typWartosc
      && includes(wybrane[key], ETypyWyjazdu.objazdWypoczynek)
      && includes(wybrane[key], ETypyWyjazdu.objazdWypoczynekPotwierdzony)
    ) {
      const typyWyjazdu = wybrane[key];

      typyWyjazdu.forEach((elem, index, arr) => {
        if (elem === ETypyWyjazdu.objazdWypoczynek) {
          arr.splice(index, 1);
        }
      });
    }
  }

  body.AtrybutyMulti.Lokalizacje_HoteloProdukt = setLokalizacje_HoteloProdukt(
    rootState.filtry.wybraneDokad,
    rootState.filtry.hoteloProdukt,
  );

  if (!body.AtrybutyMulti.Lokalizacje_HoteloProdukt && rootState.szukaj.routeInfo.Seo.RegionUrl !== '') {
    const lokalizacje = setLokalizacje_HoteloProdukt([rootState.szukaj.routeInfo.Seo.RegionUrl], rootState.filtry.hoteloProdukt);

    if (lokalizacje) {
      body.AtrybutyMulti.Lokalizacje_HoteloProdukt = lokalizacje;
    }
  }

  rootState.filtry.typTransportu === ETransportValue.dowolny
    ? null
    : (body.AtrybutySingle.TypTransportu = setTypTransportu(rootState.filtry.typTransportu));
  body.AtrybutySingle.TerminWyjazdu = setTerminyWyjazdu(dataStart, dataKoniec);
  if (rootState.szukaj.dataWylotu.length === 1) {
    body.AtrybutyMulti.DataWylotu = [...rootState.szukaj.dataWylotu];
  }

  return body;
};
export const fetchBloczekWhenNewMarkers = async (wyszukajData, dispatch, commit) => {
  if (!(wyszukajData && wyszukajData.Wynik && wyszukajData.Wynik.length > 0)) {
    commit('setBloczek', []);
    return;
  }

  const firstBloczek = wyszukajData.Wynik.find((bloczek) => bloczek.DlugoscGeo !== null && bloczek.SzerokoscGeo !== null);

  if (!firstBloczek) return;

  await dispatch('fetchBloczek', firstBloczek);
};
export const fetchBloczkiPierwszaStrona = async (wyszukajData, perPage, currentPage, dispatch, commit, payload) => {
  if (!(wyszukajData && wyszukajData.Wynik && wyszukajData.Wynik.length > 0)) {
    commit('bloczki', []);
    commit('loadedBloczki', true);
    return;
  }

  const pierwszaStrona = chunk(wyszukajData.Wynik, perPage)[currentPage];

  await dispatch('fetchBloczki', { pierwszaStrona, payload });
};
export const saveSearchHistory = async (wyszukajData, ostatnieWyszukiwania, payload, rootState, rootGetters, commit, dispatch, ssrUrl) => {
  if (!(wyszukajData && wyszukajData.Wynik && wyszukajData.Wynik.length > 0) || !payload.DatyUrodzenia.length) return;

  const ostatnieWyszukiwaniaTemp = cloneDeep(ostatnieWyszukiwania);
  let url = '';

  if (process.client) {
    url = new URL(window.location.href);
  } else {
    url = new URL(ssrUrl);
    url = new URL(`${url.protocol}//r.pl${url.pathname}${url.search}`);
  }

  const obj = {
    kierunki: [],
    termin: '',
    konfiguracja: '',
    skad: [],
    wyzywienie: [],
    link: url,
  };

  if (!!payload.AtrybutyMulti?.Lokalizacje_HoteloProdukt || !!payload.AtrybutyMulti?.Miasta || !!rootState.filtry.data) {
    if (payload.AtrybutyMulti?.Lokalizacje_HoteloProdukt) {
      forEach(payload.AtrybutyMulti.Lokalizacje_HoteloProdukt, (item) => {
        let kierunek = find(rootState.filtry.lokalizacjeFlat, ['Wartosc', item]);

        if (!kierunek) {
          kierunek = find(rootState.filtry.hoteloProdukt, ['Wartosc', item]);
        }

        kierunek ? obj.kierunki.push(kierunek.Nazwa) : null;
      });
    } else {
      obj.kierunki.push('Dowolne');
    }

    if (payload.AtrybutyMulti?.Miasta) {
      forEach(payload.AtrybutyMulti.Miasta, (item) => {
        const miasto = find(rootState.filtry.miastaFlat, ['Wartosc', item]);

        obj.skad.push(miasto.Nazwa);
      });
    } else {
      obj.skad.push('Dowolne');
    }

    if (payload.AtrybutyMulti?.Wyzywienia) {
      const wyzywienia = find(rootState.filtryBoczne.filtry, 'Wartosc', 'Wyzywienia');

      forEach(payload.AtrybutyMulti.Wyzywienia, (item) => {
        const wyzywienie = find(wyzywienia.Pola, ['Wartosc', item]);

        obj.wyzywienie.push(wyzywienie.Nazwa);
      });
    } else {
      obj.wyzywienie.push('Dowolne');
    }

    const dorosli = rootGetters['filtry/liczbaDoroslych'] === 1
      ? `${rootGetters['filtry/liczbaDoroslych']} dorosły`
      : `${rootGetters['filtry/liczbaDoroslych']} dorosłych`;
    const dzieci = rootGetters['filtry/liczbaDzieci'] === 0
      ? false
      : rootGetters['filtry/liczbaDzieci'] === 1
        ? `${rootGetters['filtry/liczbaDzieci']} dziecko`
        : `${rootGetters['filtry/liczbaDzieci']} dzieci`;

    obj.konfiguracja = dzieci ? `${dorosli}, ${dzieci}` : dorosli;

    if (rootState.filtry.data) {
      if (rootState.filtry.data[1]) {
        obj.termin = isValid(rootState.filtry.data[0])
          && `${format(rootState.filtry.data[0], dateDisplayFormat)} - ${format(rootState.filtry.data[1], dateDisplayFormat)}`;
      } else {
        obj.termin = isValid(rootState.filtry.data[0]) && `${format(rootState.filtry.data[0], dateDisplayFormat)}`;
      }
    } else {
      obj.termin = 'Dowolny';
    }

    if (ostatnieWyszukiwaniaTemp?.length !== 3) {
      const findObject = find(ostatnieWyszukiwaniaTemp, { kierunki: obj.kierunki, konfiguracja: obj.konfiguracja, termin: obj.termin });

      findObject ? remove(ostatnieWyszukiwaniaTemp, { kierunki: obj.kierunki, konfiguracja: obj.konfiguracja, termin: obj.termin }) : null;
      ostatnieWyszukiwaniaTemp?.unshift(obj);
    } else {
      const findObject = find(ostatnieWyszukiwaniaTemp, { kierunki: obj.kierunki, konfiguracja: obj.konfiguracja, termin: obj.termin });

      if (findObject) {
        remove(ostatnieWyszukiwaniaTemp, { kierunki: obj.kierunki, konfiguracja: obj.konfiguracja, termin: obj.termin });
      } else {
        ostatnieWyszukiwaniaTemp.pop();
      }

      ostatnieWyszukiwaniaTemp?.unshift(obj);
    }

    commit('setOstatnieWyszukiwania', ostatnieWyszukiwaniaTemp);
    dispatch('setSearchHistoryInCookie', ostatnieWyszukiwaniaTemp);
  }
};

export const setParams = (paramsUpperCase, rootState) => {
  const clonedParams = cloneDeep(paramsUpperCase);
  const params = lowerCaseKeys(paramsUpperCase);

  params.widok = rootState.szukaj.shownComponent === 'bloczki' ? 'list' : 'map';
  rootState.filtry.typTransportu === ETransportValue.dowolny
    ? (clonedParams.AtrybutySingle.TypTransportu = [rootState.filtry.typTransportu])
    : null;

  if (clonedParams.AtrybutySingle.TypTransportu.length > 1 && clonedParams.AtrybutySingle.TypTransportu[0] === ETransportValue.air) {
    clonedParams.AtrybutySingle.TypTransportu.length = 1;
  }

  clonedParams.AtrybutySingle.data = clonedParams.AtrybutySingle.TerminWyjazdu;
  delete clonedParams.AtrybutySingle.TerminWyjazdu;
  const dlugoscPobytuParams = prepareDlugoscPobytuParam(clonedParams.AtrybutySingle.DlugoscPobytu);

  delete clonedParams.AtrybutySingle.DlugoscPobytu;
  const cenaParams = prepareCenaParam(clonedParams.AtrybutySingle.Cena);

  delete clonedParams.AtrybutySingle.Cena;
  const datyUrodzeniaParams = prepareDatyUrodzeniaParam(clonedParams.DatyUrodzenia);

  const paramsOmitAttributes = omit(params, [
    'atrybutyMulti',
    'atrybutySingle',
    'czyWeekendowka',
    'datyUrodzenia',
  ]);

  if (clonedParams.AtrybutyMulti.Lokalizacje_HoteloProdukt) {
    clonedParams.AtrybutyMulti.wybraneDokad = clonedParams.AtrybutyMulti.Lokalizacje_HoteloProdukt.filter(
      (value) => !Number.isInteger(value * 1),
    );
    clonedParams.AtrybutyMulti.wybraneHoteloProdukty = clonedParams.AtrybutyMulti.Lokalizacje_HoteloProdukt.filter((value) => Number.isInteger(value * 1));
  }

  delete clonedParams.AtrybutyMulti.Lokalizacje_HoteloProdukt;
  if (clonedParams.AtrybutySingle.TypTransportu[0] === ETransportValue.dowolny) {
    if (clonedParams.AtrybutyMulti.Miasta) {
      const dowolneWybraneSkad = [];

      clonedParams.AtrybutyMulti.Miasta.forEach((element) => {
        if (element in wybraneSkadPolaczone) {
          dowolneWybraneSkad.push(wybraneSkadPolaczone[element]);
        } else if (element.length !== 3) {
          dowolneWybraneSkad.push(element);
        }
      });
      clonedParams.AtrybutyMulti.wybraneSkad = dowolneWybraneSkad;
    }
  } else {
    clonedParams.AtrybutyMulti.wybraneSkad = clonedParams.AtrybutyMulti.Miasta;
  }

  delete clonedParams.AtrybutyMulti.Miasta;

  if (paramsOmitAttributes.liczbaPokoi === null) {
    paramsOmitAttributes.dowolnaLiczbaPokoi = 'tak';
  } else {
    paramsOmitAttributes.dowolnaLiczbaPokoi = 'nie';
  }

  const atrybutyMulti = queryString.stringify(lowerCaseKeys(clonedParams.AtrybutyMulti), { arrayFormat: 'none' });
  const atrybutySingle = queryString.stringify(lowerCaseKeys(clonedParams.AtrybutySingle), { arrayFormat: 'none' }) + cenaParams + dlugoscPobytuParams;
  const otherParams = queryString.stringify(paramsOmitAttributes, { arrayFormat: 'none' });
  const dorosliDzieciNuxt3 = queryString.stringify(datyUrodzeniaParams, { arrayFormat: 'none' });

  const url = new URL(window.location.href);
  const query = `${dorosliDzieciNuxt3}&${otherParams}&${atrybutySingle}`;

  atrybutyMulti ? (url.search = `${query}&${atrybutyMulti}`) : (url.search = query);
  history.replaceState({}, null, url);
};
// Stare tworzenie parametrów - musi zostać w razie potrzeby powrotu!!!
// export const setParams = (paramsUpperCase, rootState) => {
//   console.log({ paramsUpperCase });
//   const params = lowerCaseKeys(paramsUpperCase);

//   params.widok = rootState.szukaj.shownComponent;
//   rootState.filtry.typTransportu === ETransportValue.dowolny
//     ? (paramsUpperCase.AtrybutySingle.TypTransportu = [rootState.filtry.typTransportu])
//     : null;

//   const paramsOmitAttributes = omit(params, ['atrybutyMulti', 'atrybutySingle', 'czyWeekendowka']);
//   const atrybutyMulti = queryString.stringify(lowerCaseKeys(paramsUpperCase.AtrybutyMulti), { arrayFormat: 'bracket' });
//   const atrybutySingle = queryString.stringify(lowerCaseKeys(paramsUpperCase.AtrybutySingle), { arrayFormat: 'bracket' });
//   const otherParams = queryString.stringify(paramsOmitAttributes, { arrayFormat: 'bracket' });

//   const url = new URL(window.location.href);
//   const query = `${otherParams}&${atrybutySingle}`;

//   atrybutyMulti ? (url.search = `${query}&${atrybutyMulti}`) : (url.search = query);
//   history.replaceState({}, null, url);
// };

export const createParamsWidgetSzukaj = (state, rootState, commit) => {
  let date;
  const dataWylotuParam = [];

  if (!state.lastSearchedDateTerminy) {
    date = rootState.filtry.TerminMin;
  } else {
    date = state.lastSearchedDateTerminy;
  }

  const zakresWczytywania = rootState.szukaj.routeInfo.Filtr.ZakresWczytywania || 7;

  dataWylotuParam.push(...[format(date, 'y-MM-dd'), zakresWczytywania.toString()]);

  const params = parseWyszukajBody(rootState);

  params.AtrybutyMulti.DataWylotu = dataWylotuParam;

  commit('lastSearchedDateTerminy', add(date, { days: zakresWczytywania }));
  return params;
};
